import type { WBankAccountView } from '@zola/svc-web-api-ts-client';
import ApiService from '@zola-helpers/client/dist/es/http/api';

export const getBankAccountForRegistry = (registryObjectId: string) => {
  return ApiService.get<WBankAccountView>(
    `/web-registry-api/v1/cash-settings/${registryObjectId}/bank-account`
  );
};
